window.treeEvaluation = (() => {
  /* ************************************************** */
  /* ******************** VAR/CONST ******************* */
  /* ************************************************** */
  const intLabels = {
    es: {
      buttons: {
        no: "No",
        yes: "Si",
        finalize: "Finalizar",
      },
      not_apply: 'No Aplica' 
    },
    en: {
      buttons: {
        no: "No",
        yes: "Yes",
        finalize: "Finalize",
      },
      not_apply: 'Not Apply'
    }
  };

  /* ************************************************** */
  /* **************** PUBLIC FUNCTIONS **************** */
  /* ************************************************** */
  //
  let changeChildSelected = (action='next') => {
    let current_element = document.querySelector(".child-tree.active"),
        current_parent = document.querySelector(".parent-active"),
        parents = Array.from(document.querySelectorAll('.card-header')),
        current_index = parents.indexOf(current_parent),
        flag = true;
    
    if (action === 'next') {
      if (current_element.nextElementSibling) {
        current_element.nextElementSibling.click();
      } else {
        if (parents[current_index + 1]) {
          parents[current_index + 1].nextElementSibling.querySelector('.child-tree').click();
          parents[current_index + 1].querySelector('button').click();
        } else {
          flag = false;
        }
      }
    } else {
      if (current_element.previousElementSibling) {
        current_element.previousElementSibling.click();
      } else {
        if (parents[current_index - 1]) {
          parents[current_index - 1].nextElementSibling.querySelector('.child-tree:last-child').click();
          parents[current_index - 1].querySelector('button').click();
        } else {
          flag = false;
        }
      }
    }

    return flag;
  };

  //
  let changeLabelSaveButton = () => {
    let last_parent = document.querySelector('.card:last-child .card-header').getAttribute('id'),
        last_child = document.querySelector('.card:last-child').querySelector('.child-tree:last-child').getAttribute('id'),
        selected_parent = document.querySelector('.card-header.parent-active').getAttribute('id'),
        selected_child = document.querySelector('.child-tree.active').getAttribute('id');
    
    document.querySelector('#btn-save label').classList.add('d-none');
    document.querySelector('#btn-save svg').classList.remove('d-none');

    if (last_parent === selected_parent && last_child === selected_child) {
      document.querySelector('#btn-save label').classList.remove('d-none');
      document.querySelector('#btn-save svg').classList.add('d-none');
    }
  };

  // Create tree structure
  let generateTree = async () => {
    if (document.getElementById('evaluationParentTree')) {
      let tree = await ajaxGetTree(),
        parents = tree.tree.filter(el => el.parent === '#'),
        html = '',
        children = '';

      try {
        document.getElementById('column-tree-filter').setAttribute('data-subtree', tree.tree.filter(el => el.parent !== '#').map(el => el.id));

        parents.forEach(tree_parent => {
          children = getChildren(tree.tree, tree.tree_evaluated, tree_parent.id);

          html += `<div class="card">
              <div class="card-header" id="parent_${tree_parent.id}" data-text="${tree_parent.question}">
                <div class="mb-0">
                  <button class="btn btn-block text-left p-0 pr-3 collapsed" type="button" data-toggle="collapse" data-target="#childrenParent${tree_parent.id}" aria-expanded="true" aria-controls="childrenParent${tree_parent.id}">
                    ${tree_parent.code} - ${tree_parent.question}
                  </button>
                  <span id="accumulatorParent${tree_parent.id}" class="badge badge-success accumulator">
                    <span id="parent_evaluated_questions_${tree_parent.id}">${children.total.evaluated}</span>
                    /
                    <span id="parent_total_questions_${tree_parent.id}">${children.total.questions}</span>
                  </span>
                </div>
              </div>
          
              <div id="childrenParent${tree_parent.id}" class="collapse" aria-labelledby="parent_${tree_parent.id}" data-parent="#evaluationParentTree">
                <div class="card-body childrens">
                  ${children.html}
                </div>
              </div>
            </div>`;
        });
      } catch (error) {
        console.log(error);
      }

      document.getElementById("evaluationParentTree").innerHTML = html;
      displaynode();
      getQuestions();
    }
  };

  //
  let getQuestionsAnswered = () => {
    let questions = [];

    try {
      document.querySelectorAll('input[type=radio]:checked').forEach(answer => {
        questions.push({
          id: answer.getAttribute('data-evaluation') || null,
          survey_body_id: answer.getAttribute('data-question'),
          qualified_value: answer.value,
          does_not_apply: false,
          observations: document.getElementById(`observations_${answer.getAttribute('data-question')}`).innerHTML
        });
      });  
    } catch (error) {
      questions;
    }
    
    try {
      document.querySelectorAll('input[type=checkbox]:checked').forEach(answer => {
        questions.push({
          id: answer.getAttribute('data-evaluation') || null,
          survey_body_id: answer.getAttribute('data-question'),
          qualified_value: 0,
          does_not_apply: true,
          observations: document.getElementById(`observations_${answer.getAttribute('data-question')}`).innerHTML
        });
      });
    } catch (error) {
      questions;
    }

    return questions;
  };

  //
  let saveResponses = async () => {
    let questions = getQuestionsAnswered(),
        response;

    try {
      document.getElementById('layer-loading-tree').classList.toggle('d-none');
      
      if (questions.length > 0 && document.getElementById('col-questions').getAttribute('data-saved') === 'false') {
        response = await saveSurvey(questions);
        if (response.ok) {
          let evaluation = document.getElementById('evaluation-header').getAttribute('data-evaluation-header');
          document.getElementById('col-questions').setAttribute('data-saved', 'true');
          localStorage.removeItem(`${evaluation}_unsaved_questions_${document.querySelector('.child-tree.active').getAttribute('data-child')}`);
        } else {
          swal('unsaved data. There was a problem saving the data, please contact our technical team');
        }
      }

      document.getElementById("strategy").scrollIntoView();
    } catch (error) {
      console.log(error);
    }

    document.getElementById('layer-loading-tree').classList.toggle('d-none');
    return response;
  };

  /* ************************************************** */
  /* **************** PRIVATE FUNCTIONS *************** */
  /* ************************************************** */
  // Get last question rated or updated
  let ajaxGetLastQuestionAnswered = async () => {
    return fetch(`/evaluation_headers/${getEvaluationHeader()}/get_last_answered`)
    .then( response => { return response.json() } )
    .then( json => { return json; } );
  };

  // Get list of questions of the selected content
  let ajaxGetQuestions = async current_subtree => {
    return fetch(`/survey_headers/${getSurveyHeader()}/survey_bodies/${current_subtree}/children_task.json?` + new URLSearchParams({
      evaluation_header: getEvaluationHeader()
    }))
    .then( handleErrors )
    .then( json => { return json; } )
    .catch( error => {
      console.log(error);
      swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
    });
  };

  //
  let ajaxGetTree = async () => {
    return fetch(`/survey_headers/${getSurveyHeader()}/survey_bodies/tree_filter_evaluation?` + new URLSearchParams({
      lang: getLanguage(), 
      evaluation_header: getEvaluationHeader()
    }))
    .then( response => { return response.json() } )
    .then( json => { return json; } );
  };

  // Display last qualified parent
  let displaynode = async () => {
    let last_qualified = await ajaxGetLastQuestionAnswered(),
        current_question;

    try {
      if (last_qualified.parent_id > 0) {
        current_question = document.getElementById(`children${last_qualified.parent_id}`);

        document.querySelector(`#parent_${current_question.getAttribute('data-parent')} button`).click();
        current_question.click();
      } else {
        document.getElementById("evaluationParentTree").firstChild.getElementsByTagName("button")[0].click();
        document.getElementById("evaluationParentTree").firstChild.querySelector('.card-body ul li').click();
      }
    } catch (error) {
      console.log(error);
      document.getElementById("evaluationParentTree").firstChild.getElementsByTagName("button")[0].click();
      document.getElementById("evaluationParentTree").firstChild.querySelector('.card-body ul li').click();
    }
  };

  // Get children for specific tree parent
  let getChildren = (tree, data_evaluated, parent_id) => {
    let children = tree.filter(el => el.parent === parent_id.toString()),
        html = '<ul>',
        total = { questions: 0, evaluated: 0 },
        compliance = [];
    
    try {
      children.forEach(child => {
        compliance = data_evaluated[child.id] || [ 0, 0 ];
        total.questions += parseInt(compliance[0]);
        total.evaluated += parseInt(compliance[1]);
        html += `<li class="child-tree" id="children${child.id}" data-parent="${parent_id}" data-child="${child.id}" data-text="${child.question}">
            ${child.code} - ${child.question}
            <span class="badge badge-info children_accumulator">
              <span id="child_evaluated_questions_${child.id}">${compliance[1]}</span>
              /
              <span id="child_total_questions_${child.id}">${compliance[0]}</span>
            </span>
          </li>`;
      });
    } catch (error) {
      html;
    }

    html += '</ul>';
    return { total: total, html: html };
  };

  // Get attribute ID [evaluation header] from tree container
  let getEvaluationHeader = () => {
    try {
      return document.getElementById('evaluationParentTree').getAttribute('data-evaluation-header');
    } catch (error) {
      return "0";
    }
  };

  // Get attribute LANG from html tag
  let getLanguage = () => document.getElementsByTagName('html')[0].getAttribute('lang');

  // Observe click children
  let getQuestions = () => {
    try {
      let elements = document.getElementsByClassName('child-tree'),
          keys = Object.keys(elements);
      
      keys.forEach(child => {
        elements[child].addEventListener('click', async event => {
          let parent_id = event.target.getAttribute('id').replace('children', ''),
              questions = await ajaxGetQuestions(parent_id);
          
          await saveResponses();
          document.getElementById('strategy').innerHTML = document.getElementById(`parent_${event.target.getAttribute('data-parent')}`).getAttribute('data-text');
          document.getElementById('task').innerHTML = event.target.getAttribute('data-text');
          document.getElementById('questions').innerHTML = htmlSurveyStructure(questions);
          document.getElementById('col-questions').setAttribute('data-saved', 'false');
          toggleActiveClassLiTree(event.target);
          qualifyTemporaryResponses(parent_id);
          changeLabelSaveButton();
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Get attribute ID [evaluation header] for tree container
  let getSurveyHeader = () => {
    try {
      return document.getElementById('evaluationParentTree').getAttribute('data-survey-header');
    } catch (error) {
      return "0";
    }
  };

  // Error handling for ajax requests
  let handleErrors = response => {
    if (!response.ok)
      throw Error(response.json());
    
    return response.json();
  };

  // HTML structure of the questions of the selected content
  let htmlSurveyStructure = questions => {
    let new_survey_html = '';
    
    try {
      questions.childrens.forEach(child => {
        new_survey_html += `
          <tr>
            <td style="background-color: ${child.type_capacity.bg_color}; color: ${child.type_capacity.color};">
              ${child.type_capacity.translation}
            </td>
            <td>${child.question}</td>
            <td>${htmlSurveyStructureAnswers(questions.id, child)}</td>
            <td class="text-center align-middle">
              ${
                child.criterion === 0 ? 
                `<input type="checkbox" name="does_not_apply" id="does_not_apply_${child.id}" 
                  data-parent="${questions.id}" 
                  data-evaluation="${child.evaluation.evaluation_id}" 
                  data-question="${child.id}" ${child.evaluation.does_not_apply ? 'checked': ''} />
                <label>${intLabels[getLanguage()].not_apply}</label>` 
                : 
                ''
              }
            </td>
            <td class="text-center align-middle">
              <a id="comment_${child.id}" class="text-info"
                data-toggle="modal"
                data-target="#observations-modal"
                data-question="${child.id}"
                data-question-text="${child.question}">
                <i class="far fa-comment-dots fa-2x"></i>
              </a>
              <label id="observations_${child.id}" data-parent="${questions.id}" class="d-none">${child.evaluation.observations}</label>
            </td>
          </tr>
        `;
      });
    } catch (error) {
      new_survey_html;
    }

    return new_survey_html;
  };

  // HTML Structure of the answers for the questions
  let htmlSurveyStructureAnswers = (parent, current_question) => {
    let new_answers_html = '';

    current_question.answer.options.forEach(answer => {
      new_answers_html += `
        <div>
          <input type="radio"
            id="answer_${current_question.id}"
            name="answer_${current_question.id}"
            value="${answer.value}"
            data-evaluation="${current_question.evaluation.evaluation_id}"
            data-question="${current_question.id}"
            data-parent="${parent}"
            data-dependants="${current_question.dependant_questions[answer.value] || ''}"
            ${current_question.evaluation.qualified_value === answer.value ? 'checked' : ''}
          />
          <label>${answer.text}</label>
        </div>
      `;
    });

    return new_answers_html;
  };

  //
  let qualifyTemporaryResponses = parent => {
    try {
      let evaluation = document.getElementById('evaluation-header').getAttribute('data-evaluation-header'),
          responses = JSON.parse(localStorage.getItem(`${evaluation}_unsaved_questions_${parent}`));

      if (responses) {
        responses.forEach(answer => {
          if (answer.does_not_apply) {
            if (document.getElementById(`does_not_apply_${answer.survey_body_id}`))
              document.getElementById(`does_not_apply_${answer.survey_body_id}`).click();
          }
          else {
            document.querySelector(`[name=answer_${answer.survey_body_id}][value="${answer.qualified_value}"]`).click();
          }

          document.getElementById(`observations_${answer.survey_body_id}`).innerHTML = answer.observations;
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //
  let saveSurvey = async (questions) => {
    let data = { 
          evaluation_header: { evaluation_bodies_attributes: questions },
          node_structure: ''
        };
    
    try {
      return fetch(`/evaluation_headers/${getEvaluationHeader()}.json`, {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.getElementById('save_token').value
          }),
          body: JSON.stringify(data)
        })
        .then(json => json)
        .catch(error => {
          console.log(error);
          
          return error;
        });
    } catch (error) {
      swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
      console.log(error);
    }
  };

  // Assign the active classes to the tree
  let toggleActiveClassLiTree = current_element => {
    let parent_id = current_element.getAttribute('data-parent');

    document.querySelectorAll('.tree-structure .childrens ul li.active').forEach(element => {
      element.classList.remove('active');
    });

    document.querySelectorAll('.tree-structure .parent-active').forEach(element => {
      element.classList.remove('parent-active');
    });

    document.getElementById(`parent_${parent_id}`).classList.add('parent-active')
    current_element.classList.add('active');
  };

  /* ************************************************** */
  /* ****************** RETURN METHOD ***************** */
  /* ************************************************** */
  return {
    initialize: generateTree,
    questionsAnswered: getQuestionsAnswered,
    save: saveResponses,
    changeChild: changeChildSelected,
    changeLabelSaveButton: changeLabelSaveButton
  };
})();